'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('promotionrequestListCtrl', function ($scope, $rootScope, $state, $http, $filter, permissionService, settings, apiSettings, list, MessageService, FileSaver, PromotionRequest, Reports, WorkflowApproval, status, workflowPendingDaysLate) {
	var vm = this;

	var $translate = $filter('translate');

	vm.permissions = permissionService;
	vm.status = status;
	vm.workflowPendingDaysLate = parseInt(workflowPendingDaysLate.value);

	angular.extend($scope.$parent.vm, {
		title: 'promotionRequests.settings.title',
		insertUrl: vm.permissions.isAuthorized('InsertPromotionRequests')? 'main.promotionrequest-edit' : null
	});

	$rootScope.laddaLoading = false;

	// Pagination
	vm.pagination = {
		list: list,
		currentPage: 1,
		pageSize: apiSettings.defaultPageSize,
		pagesTotal: list.total
	};

	$scope.$watch('vm.pagination.currentPage', function (newValue, oldValue) {
		if (newValue !== oldValue) {
			vm.refresh(newValue);
		}
	});

	vm.IsWorkflowLate = function (days) {
		return days? (days > vm.workflowPendingDaysLate) : false; 
	};

	vm.getWorkflowPendingDaysLabel = function (days) {
		return days? "há " + days + " dia(s)" : "";
	};

	vm.getDefaultSearchParameter = function () {
		var param =
		{
			promotionRequestId: vm.promotionRequestId,
			customer: vm.customer,
			regionalManager: vm.regionalManager,
			nationalManager: vm.nationalManager,
			userName: vm.userName,
			startsOn: vm.startsOn,
			endsOn: vm.endsOn,
			statusId: vm.statusId,
			workflowPendingDaysLate: (vm.isWorkflowLate == true? vm.workflowPendingDaysLate : null)
		}

		return param;
	};

	vm.search = function () {
		vm.refresh(1);
	};

	vm.refresh = function (page) {
		var params = vm.getDefaultSearchParameter(); 
		params.page = page;
		params.requiresApproval = false;

		PromotionRequest.list(params).$promise.then(function (data) {
			vm.pagination.list = data;
			vm.pagination.currentPage = data.page;
			vm.pagination.pagesTotal = data.total;
		});
	}

	vm.excel = function () {
		var params = vm.getDefaultSearchParameter();

		Reports.promotionRequestExcel(params, function (response) {
			var filename = moment().format('YYYYMMDDHHmmss') + '_Solicitacoes.xlsx';

			FileSaver.saveAs(response.data, filename);
		}, function (response) {
			var msg = $translate('errors.couldNotCompleteRequest');

			MessageService.alertError(msg);
		});
	}

	vm.cancel = function (id, index) {
		MessageService.confirm(function () {
			vm.doApproval(id, window.enumerators.statusApproval.Cancelado);
		},
		"Confirmação",
		"Deseja realmente cancelar essa solicitação?"
		);
	}

	vm.doApproval = function (id, enumStatusApproval) {
		$rootScope.laddaLoading = true;

		var params = {
			promotionRequestId: id,
			enumStatusApproval: enumStatusApproval
		};

		WorkflowApproval.update(params, function () {
			vm.refresh(vm.pagination.currentPage);
			$rootScope.laddaLoading = false;
		}, function (response) {
			MessageService.alertError(response.data);
			$rootScope.laddaLoading = false;
		});
	};
});